import { type SVGProps, forwardRef } from "react";

/**
 * VehicleIcon - Represents a vehicle.
 * Use for: Vehicle entity displays, car/vehicle selection, license plate context.
 */
export const VehicleIcon = forwardRef<
	SVGSVGElement,
	Omit<SVGProps<SVGSVGElement>, "ref"> & {
		title?: string | undefined;
		titleId?: string | undefined;
	}
>(({ strokeWidth = 1.90476, ...props }, ref) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			aria-hidden={!props.title}
			{...props}
		>
			<title>{props.title || "Vehicle"}</title>
			<path
				d="M12.0424 9.77368H5.67432"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.36719 15.1818V12.865C2.36719 12.723 2.41863 12.5361 2.49212 12.3418"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeMiterlimit="10"
			/>
			<path
				d="M7.20461 17.0925V18.2698C7.20461 18.9138 6.68281 19.4356 6.03884 19.4356H4.65259C4.00907 19.4356 3.48682 18.9138 3.48682 18.2698V17.0925"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.3256 9.77368H11.9575"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.6323 15.1818V15.8997C21.6323 15.8997 21.5289 17.0926 20.6989 17.0926H3.30054C2.47054 17.0926 2.36719 15.8997 2.36719 15.8997V15.1818H5.30228C5.75105 15.1818 6.11483 14.818 6.11483 14.3692V13.1543C6.11483 12.7056 5.75105 12.3418 5.30228 12.3418H2.49212C2.67402 11.8609 2.98958 11.3345 2.98958 11.3345L4.0791 10.1673C4.0791 10.1673 4.1581 9.89448 4.28488 9.47557C4.41441 9.04748 4.59354 8.46689 4.78876 7.86747C4.97111 7.30801 5.16724 6.73293 5.35005 6.25064C5.92054 4.74589 7.89197 4.56445 7.89197 4.56445H16.1075C16.1075 4.56445 18.0789 4.74589 18.6494 6.25064C18.8322 6.73293 19.0283 7.30801 19.2107 7.86747C19.4059 8.46689 19.585 9.04748 19.7146 9.47557C19.8414 9.89448 19.9204 10.1673 19.9204 10.1673L21.0099 11.3345C21.0099 11.3345 21.3254 11.8609 21.5073 12.3418H18.6972C18.2484 12.3418 17.8846 12.7056 17.8846 13.1543V14.3692C17.8846 14.818 18.2484 15.1818 18.6972 15.1818H21.6323Z"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.5073 12.3418C21.5808 12.5361 21.6323 12.723 21.6323 12.865V15.1818"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.98975 17.0925V14.0664H15.0097V17.0925"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20.5132 17.0925V18.2698C20.5132 18.9138 19.9909 19.4356 19.3474 19.4356H17.9612C17.3172 19.4356 16.7954 18.9138 16.7954 18.2698V17.0925"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
});

export const VehicleIconUrl = "https://offstreet.s3.us-west-2.amazonaws.com/email/car-gray.png";
